// extracted by mini-css-extract-plugin
module.exports = {"root":"_d871f6","imgContainer":"_e466d3","large":"_3c71e8"};